export default __webpack_public_path__ + "static/wireframe1-00dbe4ca93ec9f0cf7a7d4cf05236222.png";